// eslint-disable-next-line
import util from 'util';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom'

// eslint-disable-next-line
import * as MuiCore from '@material-ui/core';
// import SearchIcon from '@material-ui/icons/Search';
//import CloseIcon from '@material-ui/icons/Close';
import OutlinedPopover from '../ui/OutlinedPopover';
// import PhoneTextField from '../ui/PhoneTextField';
import { withStyles } from '@material-ui/core/styles';

import * as Formatters from '../ui/Formatters';

import * as ServiceIcons from './Icons';

import * as coreSelectors from '../core/selectors';

import * as serviceSelectors from './selectors';
import * as serviceActions from './actions';
import PhoneTextFieldWithFlag from '../ui/PhoneTextFieldWithFlag';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { getDistictFilteredAccounts } from 'utils';
import { TextRestrictedRoles } from 'constants/account.roles.constants';

const styles = theme => ({
  popOverDialogue: {
    '& .MuiPaper-root':{
      margin:'10px',
      width:'100vw'
    },
    [theme.breakpoints.up('sm')]:{
      padding: '20px'
   },
    [theme.breakpoints.up('md')]:{
      padding: '32px'
   },
  },
  popOverContainer: {
    padding:'15px 10px',
    [theme.breakpoints.up('sm')]:{
      padding: '15px 15px'
   },
    [theme.breakpoints.up('md')]:{
      padding: '15px 20px'
   },
   '&.MuiPaper-root':{
    margin:0
   },
  },
  sofia:{
   fontFamily:'Sofia',
   fontSize: 14,
   '& input, textarea':{
    fontFamily:'Sofia',
    fontSize: 14,
   }
  }
  // popper: {
  //   '& .MuiPaper-root':{
  //     width: '80vw'
  //   }
  // }
});


/*
 * Texts list
 */

class SendText extends Component {
  state = {
    message : '',
    acText: '',
    selected: true
  }

  sendText = () => {
    this.props.sendText(this.props.sourcePhoneNumberId,
                        this.props.textPhoneNumber,
                        this.state.message,
                        () => {
                          this.props.setSendTextOpen(false);
                          this.setState({message : ''});
                        });
  }

  acChange = (field, value, record) => {
    this.setState({acText: value});
  }

  selectedValue = (field, value, record) => {
    if(value !== null){
      var phoneNumber = value.contactMethods.filter(method => method.contactMethodType === 'PHONE' && method.phoneNumber.includes(this.state.acText));
      if(phoneNumber.length > 0){
        this.setState({selected: false})
        setTimeout(() => {
          this.props.setTextPhoneNumber(phoneNumber[0].phoneNumber);
          this.setState({selected: true});
        }, 20)
      } else {
        this.setState({selected: false})
        setTimeout(() => {
          this.props.setTextPhoneNumber(value.contactMethods.filter(method => method.contactMethodType === 'PHONE')[0].phoneNumber);
          this.setState({selected: true});
        }, 20);
      }
    }
  }
  getAvailablePatchNumbers(){
    // Get an array of account ids for which this user has access to the texts page
    const distinctUserAccountIds = getDistictFilteredAccounts(
      this.props.user,
      (role) => !TextRestrictedRoles.includes(role.userRoleKey)
    ).map((account) => account.accountId);
    return (this.props.user?.patchNumbers || []).filter(phone=> phone.status === 'ACTIVE' && phone.dlcVerified === 'Y' && distinctUserAccountIds.includes(phone.accountId))
  }
  handleClose(){
    this.props.setSendTextOpen(false)
    this.setState({message : ''});
  }

  render() {
    const {  sendTextOpen,
            sourcePhoneNumberId, setSourcePhoneNumberId,
            textPhoneNumber, setTextPhoneNumber,
            sendingText,
          classes } = this.props;

    return (
      <React.Fragment>
        <OutlinedPopover open={sendTextOpen}
                         icon={<ServiceIcons.TextMessageIcon color='primary'/>}
                         title='Send Text'
                         classes={{
                          root: classes.popOverContainer,
                          popper: classes.popOverDialogue
                        }}
                         onClose={()=>this.handleClose()}>
          <MuiCore.Grid container direction='column' spacing={1}>
            
            <MuiCore.Grid item>
            <MuiCore.Typography className={classes.sofia}>
                Send From
              </MuiCore.Typography>
            </MuiCore.Grid>
            
            <MuiCore.Grid item>
              <MuiCore.Select value={sourcePhoneNumberId}

                              label='Sending Number'
                              fullWidth
                              onChange={(event) => setSourcePhoneNumberId(event.target.value)}
                              input={<MuiCore.OutlinedInput className={classes.sofia}/>}>
                {this.getAvailablePatchNumbers().map(number =>(
                  <MuiCore.MenuItem key={number.phoneNumberId}
                                    value={number.phoneNumberId}
                                    className={classes.sofia}>
                    {Formatters.formatPhoneNumber(number.phoneNumber)}
                  </MuiCore.MenuItem>                    
                ))}
              </MuiCore.Select>
            </MuiCore.Grid>

            <MuiCore.Grid item >
              <MuiCore.Typography className={classes.sofia}>
              Select From Contacts
              </MuiCore.Typography>
            </MuiCore.Grid>

            <MuiCore.Grid item>
              {/* <PhoneTextField  fullWidth
                               value={textPhoneNumber}
                               onChange={(phoneNumber) => setTextPhoneNumber(phoneNumber)}/> */}
                    <Autocomplete
                        filterOptions={(options, state) => {
                          var newSuggestions = []
                          if(state.inputValue.length >= 3){
                            options.forEach(contact => {
                              if(contact.displayName.toLowerCase().includes(state.inputValue.toLowerCase()) || contact.contactMethods.filter(method => method.contactMethodType === 'PHONE' && method.phoneNumber.toLowerCase().includes(state.inputValue.toLowerCase())).length > 0){
                                newSuggestions.push(contact)
                              }
                            })
                          }
                          return newSuggestions;
                        }}
                    onInputChange={this.acChange}
                    ListboxProps={{style: {maxHeight: 180}}}
                    freeSolo={true}
                    options={this.props.user.contacts.filter(contact => contact.contactMethods.filter(method => method.contactMethodType === 'PHONE' && method.phoneNumber !== undefined).length > 0)}
                    getOptionLabel={(option) => option.displayName}
                    noOptionsText={<p>NO OPTONS</p>}
                    onChange={this.selectedValue}
                    renderInput={(params) => {
                      params.size = 'small'
                      return(<MuiCore.TextField placeholder='Begin typing' className={classes.sofia} {...params} label=""
                      />)
                    }}
                  />  
            </MuiCore.Grid>
            <MuiCore.Grid item style={{marginTop: 10}}>
              <MuiCore.Typography className={classes.sofia}>
                Enter Manually
              </MuiCore.Typography>
            </MuiCore.Grid>
            <MuiCore.Grid item>
              {this.state.selected && <PhoneTextFieldWithFlag variant='standard' value={textPhoneNumber} onPhoneNumberChange={(phoneNumber) => {
                          setTextPhoneNumber(phoneNumber)
                        }}/>}
            </MuiCore.Grid>
            
            
            <MuiCore.Grid item>
            <MuiCore.Typography className={classes.sofia}>
                  Message
              </MuiCore.Typography>
            </MuiCore.Grid>
            
              
            <MuiCore.Grid item>
              <MuiCore.TextField  fullWidth multiline rows={4}
                                  className={classes.sofia}
                                  // style={{ width: 400 }}
                                  value={this.state.message}
                                  onChange={(event) => this.setState({message: event.target.value})}/>
              
            </MuiCore.Grid>
              

            <MuiCore.Grid item style={{marginTop: 20}}>
              <MuiCore.Grid item style={{textAlign: 'center'}}>
                <MuiCore.Hidden xlDown={!sendingText}>
                  <MuiCore.CircularProgress color='primary' size={30}/>
                </MuiCore.Hidden>
                <MuiCore.Hidden xlDown={sendingText}>
                  <MuiCore.Button disabled={this.state.message.length === 0 || !textPhoneNumber || !sourcePhoneNumberId}
                                  onClick={this.sendText}>
                    Send
                  </MuiCore.Button>
                </MuiCore.Hidden>                  
              </MuiCore.Grid>
            </MuiCore.Grid>
          
          </MuiCore.Grid>
          
          
        </OutlinedPopover>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return ({
    user : coreSelectors.getUser(state),
    sendTextOpen : serviceSelectors.getSendTextOpen(state),
    sourcePhoneNumberId : serviceSelectors.getSourcePhoneNumberId(state),
    textPhoneNumber : serviceSelectors.getTextPhoneNumber(state),
    sendingText : serviceSelectors.getSendingText(state),
  });
};

const mapDispatchToProps = {
  setSourcePhoneNumberId : serviceActions.setSourcePhoneNumberId,
  setTextPhoneNumber : serviceActions.setTextPhoneNumber,
  sendText : serviceActions.sendText,
  setSendTextOpen : serviceActions.setSendTextOpen,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(SendText)));

